import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import BudgetDailySectionForm from '../../../../ReusableFormSections/reusableBudgetSections/GoogleCampaignBudgetDailySection/BudgetDailySectionForm'
import BudgetDailySectionPreview from '../../../../ReusableFormSections/reusableBudgetSections/GoogleCampaignBudgetDailySection/BudgetDailySectionPreview'
import ImpressionsBudgetDailySectionForm from './ImpressionsBudgetDailySection/ImpressionsBudgetDailySectionForm'
import ImpressionsBudgetDailySectionPreview from './ImpressionsBudgetDailySection/ImpressionsBudgetDailySectionPreview'

import useRightBudgetAndImpressionsCalculation from '../../../UploadAdCreative/useRightBudgetAndImpressionsCalculation'

import { combinedCampaignsSelector } from '../../../../../modules/selectors/combinedData'
import { UPDATE_COMBINED_CAMPAIGN } from '../../../../../modules/actions/combinedData'

import { AMOUNT_MICROS, BUDGET_DAILY, CAMPAIGN_BUDGET } from '../../../CampaignForms/fields'
import { rightSelector } from '../../../../../modules/selectors/rights'
import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS
} from '../../../Partnerships/RightForms/fields'

export const useGoogleCampaignBudgetEditSections = selectedEditItemId => {
  const combinedCampaigns = useSelector(combinedCampaignsSelector)
  const { allocation_type: rightAllocationType } = useSelector(rightSelector)
  const isBudgetAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_BUDGET
  const isImpressionAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS

  const { remainingBudget } = useRightBudgetAndImpressionsCalculation()

  const { campaigns = [] } = combinedCampaigns
  const selectedCampaign = campaigns.find(campaign => String(campaign.id) === String(selectedEditItemId))

  const campaignBudgetSection = useMemo(() => {
    // Recently created google campaign has budget in different field (campaign.campaign_budget.amount_micros)
    const budgetDaily = selectedCampaign?.[BUDGET_DAILY] || selectedCampaign?.[CAMPAIGN_BUDGET]?.[AMOUNT_MICROS]

    return {
      sectionName: CAMPAIGN_BUDGET,
      title: 'Budget',
      PreviewComponent: <BudgetDailySectionPreview budgetDaily={budgetDaily} />,
      FormComponent: (
        <BudgetDailySectionForm
          budgetDaily={budgetDaily}
          remainingBudget={remainingBudget}
          updateOptions={{
            updateType: UPDATE_COMBINED_CAMPAIGN
          }}
        />
      )
    }
  }, [selectedCampaign, remainingBudget])

  const campaignImpressionsBudgetSection = useMemo(() => {
    return {
      sectionName: 'campaign_budget_impressions',
      title: 'Impression',
      PreviewComponent: <ImpressionsBudgetDailySectionPreview campaign={selectedCampaign} />,
      FormComponent: <ImpressionsBudgetDailySectionForm />
    }
  }, [selectedCampaign])

  const editSections = useMemo(() => {
    return [
      // campaign budget section,
      ...(isBudgetAllocationType ? [campaignBudgetSection] : []),
      ...(isImpressionAllocationType ? [campaignImpressionsBudgetSection] : [])
    ]
  }, [campaignBudgetSection, campaignImpressionsBudgetSection, isBudgetAllocationType, isImpressionAllocationType])

  return { editSections, sectionsInitialOpenStates: {} }
}
